import { Plus, Trash2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { useT } from "@/i18n";

export function ProxiesFields({ proxies, onChange }) {
  const { t } = useT();
  const W = t.order.wizard;
  const set = (i, patch) => onChange(proxies.map((p, j) => (j === i ? { ...p, ...patch } : p)));
  return (
    <div data-testid="order-proxies-section" className="space-y-3">
      <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-muted-foreground">{W.proxies_title}</p>
      {proxies.map((p, i) => (
        <div key={i} data-testid={`order-proxy-${i + 1}`} className="grid grid-cols-1 sm:grid-cols-[1fr_1fr_auto] gap-3 items-start">
          <Input data-testid={`order-proxy-name-${i + 1}`} placeholder={W.proxy_name} value={p.name} onChange={(e) => set(i, { name: e.target.value })} className="bg-background" />
          <Input data-testid={`order-proxy-id-${i + 1}`} placeholder={W.proxy_id} value={p.id_number} onChange={(e) => set(i, { id_number: e.target.value })} className="bg-background" />
          <button type="button" data-testid={`order-proxy-remove-${i + 1}`} aria-label={W.proxy_remove} onClick={() => onChange(proxies.filter((_, j) => j !== i))} className="h-10 w-10 rounded-full inline-flex items-center justify-center text-brand-red hover:bg-brand-red/10 transition-colors"><Trash2 size={15} /></button>
        </div>
      ))}
      {proxies.length < 3 && (
        <button type="button" data-testid="order-proxy-add" onClick={() => onChange([...proxies, { name: "", id_number: "" }])} className="inline-flex items-center gap-1.5 text-xs font-semibold text-brand-teal hover:text-brand-tealDark transition-colors">
          <Plus size={13} /> {W.proxy_add}
        </button>
      )}
      <p className="text-xs text-muted-foreground leading-relaxed">
        {W.proxies_note}{" "}
        <a data-testid="order-proxies-docs-link" href="/biuro-wirtualne-warszawa/dokumenty" target="_blank" rel="noopener noreferrer" className="underline underline-offset-2 font-semibold text-foreground hover:text-brand-teal">{W.proxies_note_link}</a>.
      </p>
    </div>
  );
}
